import {HttpEvent, HttpEventType, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable, Subject} from 'rxjs';
import {tap} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class RequestSuccessInterceptor implements HttpInterceptor {
  public successfulRequests$ = new Subject<true>();

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      tap(e => {
        if (e.type === HttpEventType.Response && e.ok) {
          this.successfulRequests$.next(true);
        }
      })
    );
  }
}
